/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {Avatar, Typography} from '@mui/material';
import {TFunction} from 'i18next';
import {useFilteredDiagnosticReports} from '@/practitioner/hooks/diagnosticReport/api/useFilteredDiagnosticReports';
import useCurrentPractitioner from '@/practitioner/hooks/useCurrentPractitioner';
import {CircularLoading} from '@/shared/components/ui/Loading';

export default function WorkListMenuItem({t}: {t: TFunction}) {
  const practitioner = useCurrentPractitioner();
  const {
    isSuccess,
    isPending,
    data: queryData
  } = useFilteredDiagnosticReports({
    practitionerId: practitioner.id,
    page: 1,
    isReviewed: false
  });

  const data = isSuccess ? queryData!.data : null;
  const countText = data === null ? null : data.total > 0 ? `${data.total}` : '';

  return (
    <>
      <Typography
        component="span"
        sx={{
          maxWidth: '95%',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
      >
        {t('practitioner/common:menu.workList')}
      </Typography>
      {isPending ? (
        <CircularLoading progressSize={16} />
      ) : countText ? (
        <Avatar
          component="span"
          color="primary"
          sx={{
            width: 'auto',
            minWidth: 24,
            maxWidth: 24,
            height: 24,
            paddingLeft: 0.5,
            paddingRight: 0.5,
            backgroundColor: 'primary.main',
            overflow: 'hidden',
            fontSize: '0.75rem',
            fontWeight: 'bold',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
        >
          {Number(countText) < 100 ? countText : '+99'}
        </Avatar>
      ) : null}
    </>
  );
}
